import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa'

import servicesData from '../data/servicesData'
import { getServiceIcon } from './ServiceIcons'
import '../styles/components/Navbar.css'

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20
      setScrolled(isScrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setServicesDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Close dropdown on route change
  useEffect(() => {
    setServicesDropdownOpen(false)
    setMobileMenuOpen(false)
  }, [location])

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ]

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'menu-open' : ''} ${location.pathname === '/' ? 'home' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src="/figo-logo9.png" alt="Figo Digital Services" className="logo-image" />
          <div className="logo-text-container">
            <span className="logo-text">FIGO</span>
            <span className="logo-tagline">DIGITAL SERVICES</span>
          </div>
        </Link>

        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link
            to="/"
            className={location.pathname === '/' ? 'active' : ''}
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>

          {/* Services Dropdown */}
          <div
            className={`nav-dropdown ${servicesDropdownOpen ? 'open' : ''}`}
            ref={dropdownRef}
          >
            <button
              className={`nav-dropdown-trigger ${location.pathname.startsWith('/services') ? 'active' : ''}`}
              onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
            >
              Services
              <FaChevronDown className={`dropdown-arrow ${servicesDropdownOpen ? 'rotated' : ''}`} />
            </button>

            <div className="nav-dropdown-menu">
              <div className="dropdown-header">
                <Link
                  to="/services"
                  className="view-all-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  View All Services →
                </Link>
              </div>
              <div className="dropdown-grid">
                {servicesData.map((service) => (
                  service.externalLink ? (
                    <a
                      key={service.id}
                      href={service.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      style={{ '--item-color': service.color }}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <span className="dropdown-item-icon">
                        {getServiceIcon(service.id, '#fff')}
                      </span>
                      <span className="dropdown-item-label">{service.title}</span>
                    </a>
                  ) : (
                    <Link
                      key={service.id}
                      to={`/services/${service.linkTo || service.id}`}
                      className="dropdown-item"
                      style={{ '--item-color': service.color }}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <span className="dropdown-item-icon">
                        {getServiceIcon(service.id, '#fff')}
                      </span>
                      <span className="dropdown-item-label">{service.title}</span>
                    </Link>
                  )
                ))}
              </div>
            </div>
          </div>

          {navLinks.slice(1).map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={location.pathname === link.path ? 'active' : ''}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="cta-button" onClick={() => setMobileMenuOpen(false)}>
            Get Started
          </Link>
        </div>

        <div className="nav-actions">
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
